import React, { useState, useEffect } from "react";
import * as Yup from "yup";
import FormComponent from "../Form/FormComponent";
import { Dialog } from "@material-ui/core";
import { withStyles, Link } from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import {
 // EditCampaignModalConfig,
  CampaignModalConfig
} from "../Campaign/CampaignConfig";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import Typography from "@material-ui/core/Typography";
import "./campaignModal.css";
import Edit from "../assets/edit.png";
import store from "../../Redux/Store";

import { fetchMethod } from "../../FetchMethod";
import {
  EditCampaignStepsQuery,
  getLimitPerDay,
  
} from "../Campaign/campaignQueries";
// modal props must have a button title and a dialog title
const styles = theme => ({
  root: {
    margin: 0,
    padding: theme.spacing(2)
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500]
  }
});

const DialogTitle = withStyles(styles)(props => {
  const { children, classes, onClose } = props;
  return (
    <MuiDialogTitle className={classes.root}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles(theme => ({
  root: {}
}))(MuiDialogContent);

export default function CustomizedDialogs(props) {
  const [open, setOpen] = React.useState(
    props.showButton === false ? true : false
  );
  let [addsteps, setsteps] = useState({});
  let [maxLimits, setMaxlimit] = useState();
  let [limitsPerDay, setlimitsPerDay] = useState([]);

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  let maxLimit = maxLimits;

  const editcampaignModalValidation =  Yup.object().shape({
    stepname: Yup.string()
      .ensure()
      .test("stepname", "Please select step", value => {
        return value != "Select";
      }),
     
    // limitperday: Yup.string()
    //   .matches(/^\d+$/, {
    //     message: "Digits only",
    //     excludeEmptyString: true
    //   })
    //   .test("limit not put", "Please enter max. limit", function(value) {
    //     return (
    //       value !== undefined ||
    //       (store.getState().addModalStep.length >= 1 &&
    //         (this.parent.stepname === "SEND_THANKS_MESSAGE" ||
    //           this.parent.stepname === "SEND_MESSAGE") &&
    //         store.getState().addModalStep[0].stepname !== "SEND_MESSAGE")
    //     );
    //   })
    //   .test("is not zero", "Limit can't be zero", function(value) {
    //       debugger;
    //         if (this.parent.open == 1 && value == 0)  {
    //             return false;
    //            }
    //     return (
    //       value != 0 || 
    //       (store.getState().addModalStep.length >= 1 &&
    //         (this.parent.stepname === "SEND_THANKS_MESSAGE" ||
    //           this.parent.stepname === "SEND_MESSAGE") &&
    //         store.getState().addModalStep[0].stepname !== "SEND_MESSAGE")
    //     );
    //   })
    //   .test("is not max limits", "Can't exceed max limit", function(value) {
    //     debugger;
    //    //  const numericValue = Number(value);
    //     return (
    //     //  numericValue <= maxLimits 
    //          value <= maxLimits ||
    //       (store.getState().addModalStep.length >= 1 &&
    //         (this.parent.stepname === "SEND_THANKS_MESSAGE" ||
    //           this.parent.stepname === "SEND_MESSAGE") &&
    //         store.getState().addModalStep[0].stepname !== "SEND_MESSAGE")
    //     );
    //   }),

// limitperday: Yup.string()
//   .matches(/^\d+$/, {
//     message: "Digits only",
//     excludeEmptyString: true
//   })
//   .test("required-when-open-or-step", "Please enter max. limit", function (value) {
//     // Extra check
//     if ((this.parent.open == 1 || store.getState().addModalStep.length == 1) &&
//         (value === "" || value === undefined)) {
//       return false;
//     }

//     return (
//       value !== undefined ||
//       (store.getState().addModalStep.length >= 1 &&
//         (this.parent.stepname === "SEND_THANKS_MESSAGE" ||
//           this.parent.stepname === "SEND_MESSAGE") &&
//         store.getState().addModalStep[0].stepname !== "SEND_MESSAGE")
//     );
//   })
//   .test("is not zero", "Limit can't be zero", function (value) {
//     debugger;
//     if (this.parent.open == 1 && value == 0) {
//       return false;
//     }
//     return (
//       value != 0 ||
//       (store.getState().addModalStep.length >= 1 &&
//         (this.parent.stepname === "SEND_THANKS_MESSAGE" ||
//           this.parent.stepname === "SEND_MESSAGE") &&
//         store.getState().addModalStep[0].stepname !== "SEND_MESSAGE")
//     );
//   })
//   .test("is not max limits", "Can't exceed max limit", function (value) {
//     debugger;
//     return (
//       value <= maxLimits ||
//       (store.getState().addModalStep.length >= 1 &&
//         (this.parent.stepname === "SEND_THANKS_MESSAGE" ||
//           this.parent.stepname === "SEND_MESSAGE") &&
//         store.getState().addModalStep[0].stepname !== "SEND_MESSAGE")
//     );
//   }),

limitperday: Yup.string()
  .matches(/^\d+$/, {
    message: "Digits only",
    excludeEmptyString: true
  })
  .test("required-when-open-or-step", "Please enter max. limit", function (value) {
    if ((this.parent.open == 1 || store.getState().addModalStep.length == 1) &&
        (value === "" || value === undefined)) {
      return false;
    }
    return true;
  })
  .test("is not zero", "Limit can't be zero", function (value) {
    if (this.parent.open == 1 && value == 0) {
      return false;
    }
    return (
      value != 0 ||
      (store.getState().addModalStep.length >= 1 &&
        (this.parent.stepname === "SEND_THANKS_MESSAGE" ||
          this.parent.stepname === "SEND_MESSAGE") &&
        store.getState().addModalStep[0].stepname !== "SEND_MESSAGE")
    );
  })
  .test("is not max limits", "Can't exceed max limit", function (value) {
    const numericValue = Number(value);

    // 🔹 New check: if open == 1 OR step length == 1, enforce <= maxLimits
    if ((this.parent.open == 1 || store.getState().addModalStep.length == 1) &&
        numericValue > maxLimits) {
      return false;
    }

    return (
      numericValue <= maxLimits ||
      (store.getState().addModalStep.length >= 1 &&
        (this.parent.stepname === "SEND_THANKS_MESSAGE" ||
          this.parent.stepname === "SEND_MESSAGE") &&
        store.getState().addModalStep[0].stepname !== "SEND_MESSAGE")
    );
  }),

  
    daysdelay: Yup.string()
      .required("Please enter days delay")
      .matches(/^\d+$/, {
        message: "Digits only",
        excludeEmptyString: true
      })
      .max(2, "Days delay should be less than 3 digits only"),

    message: Yup.string().when("stepname", {
      is: "SEND_MESSAGE",
      then: Yup.string()
        .required("Please enter message")

        .max(3000, "Message should be less than 3000 characters")
    }),
    personalmessage: Yup.string().when("stepname", {
      is: "SEND_INVITE",
      then: Yup.string()
        
        .max(250, "Personal message should be less than 250 characters")
    }),
    replyMessage: Yup.string().when("stepname", {
      is: "SEND_THANKS_MESSAGE",
      then: Yup.string().max(
        3000,
        "Thank message should be less than 3000 characters"
      )
    })
  });

  useEffect(() => {
    fetchMethod(getLimitPerDay)
      .then(res => res.json())
      .then(res => {
        setlimitsPerDay(res.data.allSystemsettings.Systemsettings[0]);
      })
      .catch(e => console.log(e));
  }, []);

  useEffect(() => {
  
    if (props.editableData.stepname === "SEND_INVITE") {
      setMaxlimit(limitsPerDay.maxconnectionperday);
    } else if (props.editableData.stepname === "FOLLOW") {
      setMaxlimit(limitsPerDay.maxfollowperday);
    } else if (props.editableData.stepname === "VISIT") {
      setMaxlimit(limitsPerDay.maxvisitperday);
    }
     else if (props.editableData.stepname === "SEND_MESSAGE" && props.editableData.open === 1 ) {
      setMaxlimit(limitsPerDay.maxopenmessageperday);
    } 
     else {
      setMaxlimit(limitsPerDay.maxmessageperday);
    }
  });

  const renderModalContent = props => {
 
    return (
      <FormComponent
        mtitle="EDIT_MODAL_STEP"
        editableData={props.editableData}
        formConfig={CampaignModalConfig}
        limitsPerDay={limitsPerDay}
        modalClose={handleClose}
        query={
          store.getState().isEditMode === true ? EditCampaignStepsQuery : ""
        }
        formValidation={editcampaignModalValidation}
        storeArray="addModalStep"
        buttonName={"Update"}
        message="Step updated successfully"
      />
    );
  };

  return (
    <div>
      <a
        title="Edit"
        style={{ cursor: "pointer" }}
        onClick={
         
          localStorage.getItem("role") !== "CUSTOMER" ? handleClickOpen : ""
        }
      >
        <img src={Edit} />
      </a>
      <div>
        <Dialog aria-labelledby="customized-dialog-title" open={open}>
          <div className="campaignModal">
            <DialogTitle id="customized-dialog-title" onClose={handleClose}>
              <div className="CampaignModalTitle">Edit Step</div>
            </DialogTitle>
            <DialogContent>{renderModalContent(props)}</DialogContent>
          </div>
        </Dialog>
      </div>
    </div>
  );
}
